import * as React from 'react';

import {CloseButton} from 'shells/button/close-button/close-button';
// @ts-expect-error - imported from .js/.jsx file
import {ArchiveIcon} from 'shells/icon/svg/archive-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EmailIcon} from 'shells/icon/svg/email-icon';
// @ts-expect-error - imported from .js/.jsx file
import {FrownyIcon} from 'shells/icon/svg/frowny-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TickCircleIcon} from 'shells/icon/svg/tick-circle-icon';

import _ from 'underscore';

// @ts-expect-error
import {NotificationOptions} from '../../notifications/index';

// @ts-expect-error
import getClassesMixin from '../mixins/get-classes';

export type NotificationObj = {
    id: number;
    title: string;
    options: NotificationOptions;
};

type Props = {
    notification: NotificationObj;
    onClose: (arg1: NotificationObj) => void;
};

type State = {
    isOpening: boolean;
    isClosing: boolean;
};

export class Notification extends React.Component<Props, State> {
    openTimeout: number | null | undefined;
    closeTimeout: number | null | undefined;
    getClasses = getClassesMixin;

    constructor(props: Props) {
        super(props);
        this.state = {
            isOpening: true,
            isClosing: false,
        };

        // @ts-expect-error
        this.openTimeout = setTimeout(() => this.setState({isOpening: false}), 1600);
        // @ts-expect-error
        this.closeTimeout = setTimeout(() => this.handleClose(), 8000);
    }

    componentWillUnmount() {
        // @ts-expect-error
        clearTimeout(this.openTimeout);
        // @ts-expect-error
        clearTimeout(this.closeTimeout);
    }

    render() {
        const {
            title,
            options: {body},
        } = this.props.notification;

        const classes = this.getClasses('ui-notifications__notification', {
            'ui-notifications__notification--on-animate-in': this.state.isOpening,
            'ui-notifications__notification--on-animate-out': this.state.isClosing,
        });

        return (
            <li
                className={classes}
                onClick={this.handleClick}
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
            >
                {this.renderIcon()}
                <div className='ui-notification__content'>
                    <div className='ui-notification__title'>{title}</div>
                    <div className='ui-notification__body'>{body}</div>
                </div>
                <CloseButton className='ui-notification__close' onClick={this.handleClose} />
            </li>
        );
    }

    renderIcon = () => {
        const iconName = this.props.notification.options.icon;
        let icon;
        switch (iconName) {
            case 'frowny':
                icon = <FrownyIcon size={55} />;
                break;
            case 'check':
                icon = <TickCircleIcon size={55} />;
                break;
            case 'email':
                icon = <EmailIcon size={55} fill='#fff' />;
                break;
            case 'archive':
                icon = <ArchiveIcon size={55} />;
                break;
            default:
                return undefined;
        }

        return <div className='ui-notification__icon'>{icon}</div>;
    };

    handleClose = (e?: React.SyntheticEvent<any>) => {
        if (e && e.stopPropagation) e.stopPropagation();
        // @ts-expect-error
        clearTimeout(this.closeTimeout);
        // @ts-expect-error
        clearTimeout(this.openTimeout);
        // Wait half a second after state is set for animation before we remove the node
        this.setState({isClosing: true});
        _.delay(() => this.props.onClose(this.props.notification), 700);
    };

    handleClick = (e: React.SyntheticEvent<HTMLElement>) => {
        const {options} = this.props.notification;
        this.handleClose(e);
        if (options && options.onClick) options.onClick(e);
    };

    handleMouseOver = () => {
        // @ts-expect-error
        clearTimeout(this.closeTimeout);
    };

    handleMouseOut = () => {
        // @ts-expect-error
        this.closeTimeout = setTimeout(() => this.handleClose(), 7000);
    };
}
